import React, { useContext, useEffect, useRef, useState } from "react";
import DOMPurify from 'dompurify';
import styles from "../Vacancy/Vacancy.module.scss";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";
import StatesContext from "../../context/states";
import FactoidVacancy from '../../components/FactoidVacancy';
import Carousel from '../../components/Carousel';
import Form from '../../components/Form';
const Internship = () => {
  const path = useContext(PathContext);
  const states = useContext(StatesContext);
  const isMobile = useContext(MobileContext);
  const [currentId, setCurrentID] = useState(-1);
  const { hrefInternship, endpoint } = states;
  let content = null;
  let facility = null;
  const refWrap = useRef(null);
  const refCollapse = useRef(null);
  const [data, setData] = useState(null);
  const [isCollapsed, setCollapsed] = useState(true);

  const resetScroll = () => {
    if (refCollapse.current !== null) {
      refCollapse.current.scrollTop = 0;
    }
  }
  const contentFromEditor = (str, place = false) => {
    if (place) {
      if (str.length > 600) {
        return <> <div className={!isCollapsed ? `${styles.collapse} ${styles.collapse_open}` : styles.collapse} ref={refCollapse}>
          <div className={`${styles.content} ${styles.content_place}`} key={`contentFromEditor`}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(str) }}></div>

        </div>
          <div className={!isCollapsed ? `${styles.toggler} ${styles.toggler_open}` : styles.toggler} onClick={() => { setCollapsed(!isCollapsed); resetScroll() }}>
            {isCollapsed ?
              <>
                Показать все
                <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L7 6L13 1" stroke="#065BAA" />
                </svg>

              </>
              :
              <>
                Свернуть
                <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L7 6L13 1" stroke="#065BAA" />
                </svg>

              </>
            }
          </div>
        </>
      }
    }
    return <div className={`${styles.content}`} key={`contentFromEditor`}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(str) }}
    />
  };
  const factoidGenerator = (array) => {
    let result = [];
    array.sort((a, b) => b.id - a.id);
    array.forEach((element, index) => {
      let factoid = <div className={styles.factoid} key={`factoid-${index}`}><FactoidVacancy color={'green'} title={element.title} description={element.description} size={'small'} /></div>;
      result.push(factoid);
    });
    return <div className={styles.factoids} key={`factoids`}>{result}</div>;
  }
  const placeGenerator = (object) => {
    return <div className={styles.place} key={'place'}>
      <div className={styles.place__info}>
        <div className={styles.place__col}>
          <div className={styles.place__title}>{object.name}</div>
          <div className={styles.place__location}>
            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.69563 0C3.12213 0 0.231934 2.817 0.231934 6.3C0.231934 11.025 6.69563 18 6.69563 18C6.69563 18 13.1593 11.025 13.1593 6.3C13.1593 2.817 10.2691 0 6.69563 0ZM6.69563 8.55C5.42136 8.55 4.38717 7.542 4.38717 6.3C4.38717 5.058 5.42136 4.05 6.69563 4.05C7.96991 4.05 9.0041 5.058 9.0041 6.3C9.0041 7.542 7.96991 8.55 6.69563 8.55Z" fill="#BFBFBF" />
            </svg>

            {object.address}</div>
          {!isMobile && object.facts !== null ? factoidGenerator(object.facts) : null}
        </div>
        <div className={styles.place__col}>
          {contentFromEditor(object.description, true)}

          {isMobile && object.facts !== null ? factoidGenerator(object.facts) : null}
        </div>
      </div>
      {object.images !== null && object.images.length > 0 ?
        <div className={styles.place__carousel}>
          <Carousel data={object.images} />
        </div>
        : null}
    </div>
  };


  useEffect(() => {

    window.scrollTo(0, 0);
  }, []);

  // поиск id стажировки в url
  useEffect(() => {

    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const paramValue = searchParams.get('internship_id');
    if (hrefInternship !== undefined && hrefInternship !== null && hrefInternship !== -1) {
      setCurrentID(hrefInternship);
    } else if (paramValue !== null && paramValue !== -1) {
      setCurrentID(paramValue);
    } else {
      window.location.href = `${path}/vacancies${url.search}`;
    }
  }, [hrefInternship, path]);

  // загрузка информации о стажировке по id

  useEffect(() => {
    if (currentId === -1 || endpoint === null) return;
    const query = `query {
      internship(id: ${currentId}){
        name
        description
        city{
          name
        }
        experience{
          name
        }
        employment{
          name
        }
        scope{
          id
        }
        facility {
          name
          address
          description
          images {
            image {
              url
            }
          }
          facts{
            id
            title
            description
          }
        }
      }
    }
    `;
    const variables = null;
    fetch(`${endpoint}/graphql`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query, variables }),
    })
      .then(response => {
        return response.json()
      })
      .then(data => {
        setData(data.data.internship);
        refWrap.current.style.opacity = 1;
      })
      .catch(error => {
        console.error(error);
      });
  }, [currentId, endpoint]);

  if (data !== null && data.description !== null) {
    let currentArray = [];
    if (data.facility !== null) {
      facility = [];
      const title = <h3 className={`${styles.section__title} ${styles.section__title_place}`} key={`section-title-place`}>О площадке:</h3>
      facility.push(title);
      let place = placeGenerator(data.facility);
      facility.push(place);
    }
    const tempContent = contentFromEditor(data.description);
    currentArray.push(tempContent);
    content = currentArray;
  }

  let coverIndex = 0;
  if (data !== null && data.scope !== null) {
    switch (data.scope.id) {
      case 7:
        coverIndex = 2;
        break;
      case 6:
        coverIndex = 3;
        break;
      case 5:
        coverIndex = 4;
        break;
      case 1:
        coverIndex = 1;
        break;

      default:
        break;
    }
  }
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>

        <div className="container">
          {coverIndex !== 0 ?
            <div className={styles.cover} key={`cover-${coverIndex}`}>
              <picture className={styles.cover__img} >
                <source media="(max-width: 768px)" srcSet={`${path}/img/vacancy-cover-${coverIndex}-mobile.webp`} />
                <img src={`${path}/img/vacancy-cover-${coverIndex}.webp`} alt="" />
              </picture>
            </div>
            : null
          }
          <h1 className={styles.title} key={'title'}>{data !== null && data.name !== null ? data.name : null}</h1>

          <div className={styles.info}>
            <div className={styles.info__col}>
              <span>Город</span>
              <span>{data !== null && data.city !== null ? data.city.name : null}</span>
            </div>
            <div className={styles.info__col}>
              <span>Требуемый опыт</span>
              <span>{data !== null && data.experience !== null ? data.experience.name : null}</span>
            </div>
            <div className={styles.info__col}>
              <span>Тип занятости</span>
              <span>{data !== null && data.employment !== null ? data.employment.name : null}</span>
            </div>
          </div>
          {content}
          {facility}
          <div className={styles.form}>
            <h2 className={styles.form__title}>Заполните форму, чтобы откликнуться на стажировку</h2>
            <div className={styles.form__body}>
              <Form vacancyId={currentId} />
            </div>
          </div>

        </div>

      </div>
    </>
  );

}

export default Internship;
